const CONFIGS_RESUMOS = {};

export default CONFIGS_RESUMOS;
